import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {eventIsPaused} from '../../checkout/selectors/event'
import Translation from "../../shared/Translation";

class SalesPaused extends Component<SalesPausedProps> {
  render() {
    if (!this.props.isPaused) {
      return null;
    }

    return (
      <div className="event-details__sale-status">
        <Translation>{'checkout__online_sales_are_currently_paused'}</Translation>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  return {
    locale: state.intl.locale,
    isPaused: !!eventIsPaused(state),
  }
}

const mapDispatchToProps = dispatch => {
  return bindActionCreators({}, dispatch);
}

SalesPaused.propTypes = {
  locale: PropTypes.string.isRequired,
  isPaused: PropTypes.bool.isRequired,
}

export default connect(mapStateToProps, mapDispatchToProps)(SalesPaused)
